import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { HexIconComponent } from '../shared/hex-icon/hex-icon.component';

interface Punto {
  color: string;
  label: string;
}

/**
 * "Desarrollo a medida" (home Híbrido v2): lo que el estándar no cubre se
 * desarrolla sobre la misma plataforma, sin migrar datos ni duplicar
 * información. Los servicios de agencia (web, hosting) viven en /servicios.
 */
@Component({
  selector: 'app-otros-servicios',
  standalone: true,
  imports: [RouterLink, HexIconComponent],
  templateUrl: './otros-servicios.component.html',
  styleUrl: './otros-servicios.component.scss',
})
export class OtrosServiciosComponent {
  puntos: Punto[] = [
    { color: 'var(--ts-mod-plataforma)', label: 'Módulos y verticales propios' },
    { color: 'var(--ts-mod-facturacion)', label: 'Integraciones con tus sistemas' },
    { color: 'var(--ts-mod-crm)', label: 'Todo unificado, sin duplicar datos' },
  ];
}
